import { BUSINESS_SCHEMA, USER_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";
import { database } from "../index";

const business = database.collections.get(BUSINESS_SCHEMA);

export const observeAllBusiness = () => business.query(Q.where("is_active", false), Q.on(USER_SCHEMA, "is_active", true)).observeWithColumns(["name", "category", "is_active", "last_active_at"]);

export const observeBusiness = (id) => business.query(Q.where("id", id), Q.on(USER_SCHEMA, "is_active", true)).observeWithColumns(["name", "category", "is_active", "last_active_at"]);

export const getDifferentBusinesses = async (id) => await business.query(Q.where("id", Q.notEq(id)), Q.on(USER_SCHEMA, "is_active", true)).fetch();

export const getBusinessCount = async () => await business.query(Q.on(USER_SCHEMA, "is_active", true)).fetchCount();

export const getBusinessFromUser = (number) => business.query(Q.on(USER_SCHEMA, "phone_number", number)).observe();

export const getAllActiveBusinesses = async () => await business.query(Q.where("is_active", true)).fetch();
export const getBusinessId = async (id) => await business.query(Q.where("id", id)).fetch();

export const observeActiveBusiness = (number) =>
  business
    .query(
      Q.where("is_active", true),
      Q.on(USER_SCHEMA, "is_active", true),
      Q.on(USER_SCHEMA, "phone_number", number)
    )
    .observeWithColumns(["name", "category", "is_active", "last_active_at"]);

export const getActiveBusinesses = async (name) =>
  await business
    .query(
      Q.where("is_active", true),
      Q.where("name", Q.notIn([name ?? ""])),
      Q.on(USER_SCHEMA, "is_active", true)
    )
    .fetch();


export const bulkUpdateBusiness = async (name) => {
  await database.write(async () => {
    let allActive = await getActiveBusinesses(name);
    const allRecords = await prepareUpdation(allActive);
    await database.batch(...allRecords);
  });
};

const prepareUpdation = async (allActive) => {
  return allActive.map(business => {
    try {
      return business.prepareUpdate(busi => {
        busi.is_active = false
      })
    } catch (err) {
    }
  })
};

export const updateBusinessImageUrl = async (businessRecord, imageUrl) => {
  return await database.write(async () => {
    return await businessRecord.update((b) => {
      b.image_url = imageUrl;
    });
  });
};

export const deleteBusinessImageUrl = async (businessRecord) => {
  return await database.write(async () => {
    return await businessRecord.update((b) => {
      b.image_url = null;
    });
  });
};
